import type {SmmChannelHealth} from './product-types';
export function validateSmmChannelStatus(value:unknown):readonly SmmChannelHealth[]{
  const channels=(value as {channels?:SmmChannelHealth[]})?.channels;
  if(!Array.isArray(channels))throw Error('平台狀態未能確認，請重新讀取。');
  return Object.freeze(channels.map(item=>{
    if(!item||typeof item.channel!=='string'||typeof item.detail!=='string'||!['CONNECTED','STALE','DEGRADED','OFFLINE','UNKNOWN'].includes(item.state)||typeof item.observedAt!=='string'||item.observedAt!==''&&!Number.isFinite(Date.parse(item.observedAt)))throw Error('平台狀態未能確認，請重新讀取。');
    return Object.freeze({channel:item.channel,state:item.state,detail:item.detail,observedAt:item.observedAt});
  }));
}
